import {Button, Typography} from '@mui/material'
import Popover from '@mui/material/Popover'
import {useState} from 'react'

type Props = {
  label: string
  children: JSX.Element | JSX.Element[] | string
  handleClosePopover: (close: boolean) => void
}

const PopoverCustom = ({label, children, handleClosePopover}: Props) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    handleClosePopover(true)
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined
  return (
    <>
      <Button aria-describedby={id} variant='contained' onClick={handleClick} sx={{padding: '6px 16px !important'}}>
        {label}
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <div style={{padding: '12px'}}>{children}</div>
      </Popover>
    </>
  )
}

export {PopoverCustom}
